module.exports = __webpack_public_path__ + "img/phase2-2014-01.3415c74a.jpg";